<div class="form-group" ngModelGroup="{{ formField.id }}">
    <sb-form-field-label [formField]="formField"></sb-form-field-label>
    <div class="w-100">
        <ng-template #customItemTemplate let-model="item" let-index="index">
            <div class="d-flex align-items-center mt-1 mb-1">
                @if (model.isSelected) {
                    <sb-inline-svg
                        class="icon check-icon me-2"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/Check icon.svg'">
                    </sb-inline-svg>
                } @else {
                    <!--                    todo: check this block, it is repeated many times in different components-->
                    @if (!model.isContact) {
                        <sb-user-avatar class="user-avatar-btn" [user]="model" [size]="'btn'" [isNeedTooltip]="false">
                        </sb-user-avatar>
                    } @else {
                        <sb-inline-svg
                            class="icon check-icon me-2"
                            style="padding: 2px"
                            [url]="'/sb-tools/theme/images/icons/contact.svg'">
                        </sb-inline-svg>
                    }
                }
                <div class="truncate">
                    <div class="truncate text-light">
                        <span class="truncate-name">
                            {{ model.name | truncate: 23 }}
                        </span>
                        <small class="text-light ms-1">{{ model.email }}</small>
                    </div>
                </div>
            </div>
        </ng-template>
        <div
            class="tags-input-container form-control d-flex flex-wrap"
            [ngClass]="{ 'ng-invalid': formService.isSubmitted && formField.isRequired && !formField.value }">
            @for (user of selectedUsers; track user.id; let idx = $index) {
                <div class="tag truncate">
                    @if (!user.isContact) {
                        <sb-user-avatar
                            class="user-avatar-btn me-2"
                            [user]="user"
                            [size]="'btn'"
                            [isNeedTooltip]="false">
                        </sb-user-avatar>
                    } @else {
                        <sb-inline-svg
                            class="icon check-icon me-2"
                            style="padding: 2px"
                            [url]="'/sb-tools/theme/images/icons/contact.svg'">
                        </sb-inline-svg>
                    }
                    <span class="tag-text truncate">{{ user.email }}</span>
                    <sb-inline-svg
                        class="icon icon-close"
                        role="button"
                        [attr.aria-label]="'Remove user' | translate"
                        (click)="removeUser(idx)"
                        [url]="'/sb-tools/theme/images/Svg icons WEB/Web icons/X icon.svg'">
                    </sb-inline-svg>
                </div>
            }
            <input
                name="formField{{ formField.id }}"
                #usersSelector="ngModel"
                id="form-element-{{ formField.id }}"
                autocomplete="off"
                class="typeahead-input"
                typeaheadOptionField="label"
                appFocus
                [appAutoFocus]="formField.isNeedToFocus"
                [placeholder]="formField.placeholder || 'Select users'"
                [typeaheadMinLength]="0"
                [typeaheadSelectFirstItem]="false"
                [typeaheadIsFirstItemActive]="false"
                [typeahead]="allUsers"
                [typeaheadGroupField]="'typeName'"
                [typeaheadScrollable]="true"
                [typeaheadOptionsInScrollableView]="4"
                [typeaheadItemTemplate]="customItemTemplate"
                [(ngModel)]="selectedUser"
                (typeaheadOnSelect)="addUser($event)"
                (keydown)="keyDownHandler($event)"
                (blur)="checkAndAddNewUser()"
                maxlength="1000" />
        </div>
        @if (formService.isSubmitted && !formField.value && formField.isRequired) {
            <div class="text-danger">
                @if (usersSelector.value) {
                    <span translate> Please enter a valid email address </span>
                } @else {
                    <span translate> Please fill this field </span>
                }
            </div>
        }
    </div>
</div>
